/**
 * removes all html tags from a string and only returns the text
 *
 * @param {string} string the string with html tags which will be cleared
 * @return {string} text only return
 */
const stripTags = (string) => string.replace(/<\/?[^>]+(>|$)/g, '');

export default stripTags;
